// Story 7.4 (ADO-908) — the branded product-image fallback (AC2).
//
// Shown whenever a product has no image reference OR its referenced image fails
// to load — never a browser broken-image icon, never a collapsed box. It is a
// self-contained INLINE SVG so it renders offline and issues no network request
// (the app is a PWA whose CSP blocks external hosts — a remote placeholder URL
// would be blocked). It reads as an intentional branded state (a neutral DS
// surface + a muted product glyph), not an empty gap.
//
// This SVG is purely decorative; the accessible name (the product name, AC4) is
// supplied by the caller (`ProductImage`) via `aria-label` + `role="img"` on the
// spread props, so the placeholder carries the same meaningful alt text a real
// image would. Colours use DS tokens so it tracks light/dark themes.
import type { SVGProps } from 'react';

export function ProductImagePlaceholder(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 96 96" preserveAspectRatio="xMidYMid meet" {...props}>
      <rect width="96" height="96" rx="8" fill="var(--color-background-tertiary, #ebf3fb)" />
      {/* A simple grocery-bag glyph — decorative (the caller names the element). */}
      <g
        fill="none"
        stroke="var(--color-text-tertiary, #9dafc3)"
        strokeWidth="3"
        strokeLinejoin="round"
        strokeLinecap="round"
      >
        <path d="M30 40h36l-3.5 30a4 4 0 0 1-4 3.5H37.5a4 4 0 0 1-4-3.5L30 40Z" />
        <path d="M39 40v-4a9 9 0 0 1 18 0v4" />
      </g>
    </svg>
  );
}
